import { Box, Chip, IconButton, Typography } from "@mui/material";
import { buildColumns, buildOptions } from "../../BuildColumnsOptions";
import { Edit } from "@mui/icons-material";

export const columns = (order, products, handleProductStatusOpen) =>
	buildColumns([
		...(order?.status.toLowerCase() !== "received" &&
		order?.status.toLowerCase() !== "processing" &&
		order?.status.toLowerCase() !== "order delivered"
			? [
					{
						name: "",
						label: "Action",
						sort: false,
						filter: false,
						viewColumns: false,
						cellProps: () => ({ style: { textAlign: "center" } }),
						render: (_, meta) => {
							const row = products[meta.rowIndex];
							return (
								<>
									{row.status.toLowerCase() !==
									"order delivered" ? (
										<IconButton
											color="primary"
											onClick={() =>
												handleProductStatusOpen(row)
											}
										>
											<Edit />
										</IconButton>
									) : null}
								</>
							);
						},
					},
			  ]
			: []),
		{
			name: "title",
			label: "Product",
			render: (value) => (
				<Box sx={{ display: "flex", alignItems: "center" }}>
					<Typography>{value}</Typography>
				</Box>
			),
		},
		{
			name: "status",
			label: "Status",
			cellProps: () => ({ style: { textAlign: "center" } }),
			render: (value) => (
				<Chip
					size="small"
					variant="outlined"
					color="primary"
					label={value}
					// sx={{ ml: 2 }}
				/>
			),
		},
		{
			name: "attributes",
			label: "size",
			cellProps: () => ({ style: { textAlign: "center" } }),
			render: (value) => (
				<Typography>{value?.[0]?.value || "—"}</Typography>
			),
		},
		{
			name: "quantity",
			label: "Quantity",
			cellProps: () => ({ style: { textAlign: "center" } }),
			render: (value) => <Typography>{value}</Typography>,
		},
		{
			name: "unit_price_incl_tax",
			label: "Price",
			cellProps: () => ({ style: { textAlign: "center" } }),
			render: (value) => <Typography>₹{value}</Typography>,
		},
		{
			name: "line_price_incl_tax",
			label: "Total",
			cellProps: () => ({ style: { textAlign: "right" } }),
			render: (value) => <Typography>₹{value}</Typography>,
		},
		// ...(order?.status.toLowerCase() !== "received" &&
		// order?.status.toLowerCase() !== "order delivered"
		// 	? [
		// 			{
		// 				name: "",
		// 				label: "Action",
		// 				sort: false,
		// 				filter: false,
		// 				viewColumns: false,

		// 				render: (_, meta) => {
		// 					let row = products[meta.rowIndex];
		// 					return (
		// 						<IconButton
		// 							color="primary"
		// 							onClick={() => handleProductStatusOpen(row)}
		// 						>
		// 							<Edit />
		// 						</IconButton>
		// 					);
		// 				},
		// 			},
		// 	  ]
		// 	: []),
	]);

export const options = buildOptions({
	pagination: false,
	search: false,
	elevation: 0,
	viewColumns: false,
	setTableProps: () => ({
		sx: {
			"& thead th": {
				padding: 0.5,
			},
			"& tbody td": {
				padding: 1,
			},
		},
	}),
});

export const statusColumns = (order, products, handleProductStatusOpen) =>
	buildColumns([
		{
			name: "title",
			label: "Product",
			render: (value) => (
				<Box sx={{ display: "flex", alignItems: "center" }}>
					<Typography>{value}</Typography>
				</Box>
			),
		},
		{
			name: "status",
			label: "Status",
			render: (value) => (
				<Chip
					size="small"
					variant="outlined"
					color="primary"
					label={value}
					sx={{ ml: 2 }}
				/>
			),
		},

		...(order?.status.toLowerCase() !== "received" &&
		order?.status.toLowerCase() !== "order delivered"
			? [
					{
						name: "",
						label: "Action",
						sort: false,
						filter: false,
						viewColumns: false,

						render: (_, meta) => {
							const row = products[meta.rowIndex];
							return (
								<IconButton
									color="primary"
									onClick={() => handleProductStatusOpen(row)}
								>
									<Edit />
								</IconButton>
							);
						},
					},
			  ]
			: []),
	]);
